export default "__VITE_ASSET__BmLR12qJ__"